module.exports = __webpack_public_path__ + "img/logo_nav.3f510e19.png";